import React, { useId, useState } from "react";
import classNames from "classnames";
import Select from "react-select";
import { useFormContext, Controller } from "react-hook-form";

const findOption = (options, value) => {
  const firstLevelOption = value && options.find((option) => option.value === value);
  if (firstLevelOption) {
    return firstLevelOption;
  }
  for (const option of options) {
    const groupOption = option.options?.find((sub) => sub.value === value);
    if (groupOption) {
      return groupOption;
    }
  }
};

const FormSelectField = ({ label, name, options, className, rules, search = false, ...other }) => {
  const { control } = useFormContext();
  const uniqueId = useId();
  const fieldId = `field${uniqueId}`;
  const [focused, setFocused] = useState(false);
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { /*invalid, isTouched, isDirty,*/ error },
        // formState,
      }) => (
        <div
          className={classNames("form-field", className, {
            "form-field--focused": focused,
            "form-field--filled": !!value,
            "form-field--error": !!error,
          })}
          {...other}
        >
          <label className="form-field__label" htmlFor={fieldId} id={`${fieldId}-label`}>
            {label}
            {rules?.required && <span className="form-field__asterisk">&thinsp;*</span>}
          </label>
          <div className="form-field__wrapper">
            <Select
              id={fieldId}
              ref={ref}
              name={name}
              className="form-field__select-container"
              classNamePrefix="form-field-select"
              closeMenuOnSelect={true}
              isSearchable={search}
              placeholder=""
              value={findOption(options, value)}
              onChange={(option) =>
                onChange({
                  target: {
                    value: option.value,
                  },
                })
              }
              onFocus={() => setFocused(true)}
              onBlur={(e) => {
                onBlur(e);
                setFocused(false);
              }}
              options={options}
              // menuIsOpen={true}
            />
          </div>
          {error && (
            <div className="form-field__error">
              <span>{error.message}</span>
            </div>
          )}
        </div>
      )}
    />
  );
};

export default FormSelectField;
